import React from 'react';
export const overflowTextModifier = (longText, shortText) => {
    const determinedShortText = shortText ? shortText : longText;
    return (React.createElement("span", { className: "overflower" },
        React.createElement("span", { className: "overflower-short", "aria-hidden": "true", title: longText }, determinedShortText),
        React.createElement("span", { className: "overflower-long", title: longText }, longText)));
};
//# sourceMappingURL=overflower.js.map